import React from 'react';
import Header from './Components/Header/Header';
import Navbar from '../Header/Navbar';
import BussniessWithEatCost from './Components/BussniessWithEatCost/BussniessWithEatCost';
import Our_Partner from './Components/Our Partner/Our_Partner';
import Eaist_Way from './Components/Easist Way/Easist_Way';
import GrowBussniess from './Components/Grow Bussnies/GrowBussniess';
import Footer from '../Footer/Footer';
import { Box } from '@mui/material';



    function Cateter(){
        return(
            <>
                <Box sx={{
                    width:'100%',
                }}>
                    <Navbar/>
                    <Header/>
                    <Box>
                        <BussniessWithEatCost/>
                        <Our_Partner/>
                        <Eaist_Way/>
                        <GrowBussniess/>
                        
                    </Box>
                    <Footer/>
                </Box>
            </>
        )
    }


    export default Cateter